//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../GeometricUtilities/GeometricUtilities.ShapeFrameBuilder.js";
let d=[[[0,"Subtype",1,0]],[[["index"],"GetRadius",{R_:{radius:''}},1,0],[["index","radius"],"SetRadius",{},2,0],[["index"],"GetAngle",{R_:{angle:''}},1,0],[["index","angle"],"SetAngle",{},2,0]],[]];
SPLM.GeometricUtilities.CircularFrameBuilder = class extends SPLM.GeometricUtilities.ShapeFrameBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.CircularFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.CircularFrameBuilder.Subtypes = Object.freeze({
    "Arbitrary" : "Arbitrary", "Half" : "Half", "Quarter" : "Quarter", "Full" : "Full"});

export default SPLM;